import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/base.less'
import 'lib-flexible/flexible'

import Util from './utils/util'
import Vant from 'vant'

import 'vant/lib/index.css'
//axios
import {apiAxios} from './utils/http.js'
//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(Util)

Vue.use(Vant)

Vue.prototype.$http = apiAxios;

Vue.use(VueAwesomeSwiper)

new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js